import React, { useState, FormEvent, useEffect, WheelEventHandler } from 'react';
import { useParams } from 'react-router-dom';

import {Suggest2, Suggest, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, Alert, Dialog, DialogBody, Callout, Checkbox, Tooltip } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation ,Icon} from "@blueprintjs/core";
//import { DateInput3 } from "@blueprintjs/datetime2";
import { IconNames } from "@blueprintjs/icons";
import { AxiosInstance } from 'axios';
import * as utils from "./utils";
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next';
import svgWait2 from './svg/wait2.gif'
import {ClUploadInfo,AcCodeInfo} from './Types'
import { SystemHeader,ClientPicker } from './CommonUI';
import i18next from 'i18next';
import { access } from 'fs';

import svgcaretdown from './svg/caret-down.svg'

interface PageInfo {
    n: number
}

interface PageInfo2 {
    pageno: number,
    pageShow: boolean,
    pageStartno: number,
    pageEndno: number,
    pageLast: boolean,
}


var GsbFlag: any;

var UserID: string;
var PgmCode = "H0025" ;
var isReqAuth2:boolean = false ;
 
interface ClientUploadEntryViewProps {
    gsb: AxiosInstance,
    ac: ClUploadInfo,
    ac0: ClUploadInfo,    
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onReplicate?: () => void,  
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
    ViewMode: any,
    logKey2: any,
    PgmMode:any,    
}


function ClientUploadEntryView({ gsb, ac = {} as ClUploadInfo,ac0 = {} as ClUploadInfo, baseUrl = "", token = "", onPrevRec = () => { }, onNew = () => { }, onEdit = () => { }, onDelete = () => { }, onNextRec = () => { }, ViewMode, logKey2 ,PgmMode}: ClientUploadEntryViewProps) {

    const { t, i18n } = useTranslation();       
    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)
    const [isDeletePress, setisDeletePress] = useState(false)
    const [isCanDelete, setisCanDelete] = useState(true)
    const [isDeletePress2, setisDeletePress2] = useState(false)
 

    const [isOpenDialog, setisOpenDialog] = useState(false)
    const [isOPenAlert, setisOPenAlert] = useState(false)
    const [cAction, setcAction] = useState("")
    const [AuthUser, setAuthUser] = useState("")
    const [password, setPassword] = useState("")

    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")

    const [AcName1Value, setAcName1Value] = useState("")
    const [AcName2Value, setAcName2Value] = useState("")

    const [AcStatusValue, setAcStatusValue] = useState("")

    //Listed cannnot ammmed
    const [MailListStatusValue,setMailListStatisValue] = useState(false)

    let logKey3a = logKey2.substr(0,logKey2.indexOf("*")); 
    let logKey3b = logKey2.substr(logKey2.indexOf("*")+1); 
    let logKey3c = logKey3b.substr(logKey3b.indexOf("*")+1); 
    logKey3b = logKey3b.substr(0,logKey3b.indexOf("*")); 
    logKey3c = logKey3c.substr(0,logKey3c.indexOf("*")); 

    const [d_RebateRate,setd_RebateRate ] =useState("") //useState ((utils.ParseFloat(Mail.d_RebateRate,4)).toString())
    const [showSIMore, setshowSIMore] = useState(true) 
     const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    useEffect(() => {
        setisReadOnly(false)
        setisReqAuth(false)
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("ClientUploadEntryView UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            setisReqAuth(true)
                            isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID, ac])


    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

 
  if (! ("d_acCode" in ac)) return null 

    const AcNOToolTip = 
    <div>
        <div>Account No. </div>
        <div>Cash A/C : ACCOUNT=Axxxx, CUSTODY=Pxxxx </div> 
        <div>Margin A/C : MARGIN=Mxxxx </div> 
        <div>RUNNER=Cxxxx, INTERNAL=Ixxxx </div> Stock No. cannot be Blank
   </div>

  
    return (
        <div>
            {/* define add,change,delete button */}
            <div className="Row">
                <Button className="Col-1-1" icon="direction-left" onClick={() => onPrevRec()} >Prev</Button>
                
                {/* <Button className="Col-2-1" icon="add" onClick={() => onNew()} >New</Button>
                <Button className="Col-3-1" icon="edit" onClick={() => onEdit()} >Edit</Button>
                <Button className="Col-4-1" icon="delete" onClick={() => onDelete()} >Delete</Button> */}
          
                <Button className="Col-2-1" disabled={true} icon="add" onClick={() => onNew() } >New</Button>
                <Button className="Col-3-1" disabled={isReadOnly} icon="edit" onClick={() => onEdit() } >Edit</Button>
                <Button className="Col-4-1" disabled={true} icon="delete" onClick={() => setisDeletePress(true)} >Delete</Button>
                    <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="Delete"
                        canEscapeKeyCancel={true}
                        icon="trash"
                        intent={Intent.DANGER}
                        isOpen={isDeletePress}
                        onCancel={ () => setisDeletePress(false) }
                        onConfirm={ () => { onDelete(); setisDeletePress(false) } }
                    >
                        <p>
                            Are you sure to Delete ?
                        </p>
                    </Alert>
                
                <Button className="Col-5-1" icon="direction-right" onClick={() => onNextRec()} >Next</Button>
                {/* <Button className="Col-7-2" icon="document" onClick={() => { window.open(`/#/BookClosedQty?Stkno=${Mail.d_StkNo}?IPONo=${Mail.d_IPONo}`, '_blank') } } >Book Closed Qty</Button> */}
            </div>
            <div className="Spacing-V-16" />
           <div className="Row">
                <FormGroup className="Col-1-4" label="Client A/C No."> 
                  <InputGroup readOnly value={ac.d_acCode} />
                </FormGroup>
            </div>
               
            <div className="Row">                
                <FormGroup className="Col-1-4" label="Name">
                    <InputGroup readOnly value={ac.d_acName1} /> 
                    <InputGroup readOnly value={ac.d_acName2} />
                </FormGroup>               
            </div>
        
               
            <div className="Row">              
                      
              <FormGroup className="Col-1-4" label= "Upload Address TO CCASS"> 
                  <select  id="inputCCOMPOPT" disabled={true} value={ac.d_NOCOM} >   
                        <option value="">Other</option>       
                        <option value="Y">Y-Upload</option>                                   
                        <option value="B">B-Upload Broker Address</option>
        
                  </select> 
              </FormGroup>
      
              <FormGroup className="Col-1-4" label="Receive Option"> 
 
                  <select  id="inputCCOMPOPT" disabled={true} value={ac.d_CCROPT} >       
                    <option value="">OTHER</option>                                     
                    <option value="1"> 1. to be specified by issuer </option>   
                    <option value="2"> 2. completed financial report (Chi,Eng) and general notice (Chi,Eng)</option>   
                    <option value="3">3. brief financial report (Chi,Eng) and general notice (Chi,Eng)</option>   
                    <option value="4"> 4. completed financial report (Eng) and general notice (Eng)</option>   
                    <option value="5"> 5. completed financial report (Chi) and general notice (Chi)</option>   
                    <option value="6"> 6. brief financial report (Eng) and general notice (Eng)</option>   
                    <option value="7"> 7. brief financial report (Chi) and general notice (Chi)</option>   
                    <option value="8"> 8. receive notice by e-mail and obtain information through web browsing</option> 
                  </select> 
              </FormGroup>      

          </div>
 
            <div className="Spacing-V-16"></div>
            <br></br>
            <p>Notes</p>
            <div>
                <div>Re: HKEx Circular CBU/CC/DNS/034/2003</div>
            
            </div >
 
   
        </div>
    )
}

interface ClientUploadEditProps {
    gsb: AxiosInstance,
    ac?: ClUploadInfo,  
    isNew?: boolean,
    onSave?: (stk: ClUploadInfo) => void,
    onCancel?: () => void,
    PgmMode: any,    
}


function ClientUploadEntryEdit({ gsb, ac = {} as ClUploadInfo,  isNew = false, onSave = () => { }, onCancel = () => { } ,PgmMode}: ClientUploadEditProps) {

    const [isReqAuth, setisReqAuth] = useState(false)    
    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<ClUploadInfo>()
    const imgCaretdown = <img className="downIcon" src={svgcaretdown} alt="caretdown" />
    const { t, i18n } = useTranslation();       
 
    const [AcCodeValue, setAcCodeValue] = useState(ac.d_acCode)
    const [setClCodeValue, setSetClCodeValue] = useState(() => setAcCodeValue)
    const [isClPickerOpen, setIsClPickerOpen] = useState(false)
    const [AcCodeList, setAcCodeList] = useState([] as AcCodeInfo[])
    const [AcName1Value, setAcName1Value] = useState(ac.d_acName1)
    const [AcName2Value, setAcName2Value] = useState(ac.d_acName2)
     

    const [searchStk,setsearchStk] = useState("")    
    const [CurrencyValue,setCurrencyValue] = useState("")
    const [def_d_acCode ,setdef_d_acCode] = useState (ac.d_acCode)
 
    const [def_d_CCROPT,setdef_d_CCROPT] = useState (ac.d_CCROPT)
    const [def_d_NOCOM,setdef_d_NOCOM] = useState (ac.d_NOCOM)

    const [def_d_acName1 ,setdef_d_acName1] = useState (ac.d_acName1) 
    const [def_d_acName2 ,setdef_d_acName2] = useState (ac.d_acName2)
    
    const [AcStatusValue, setAcStatusValue] = useState("")
 
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")
    const [showChannel, setshowChannel] = useState(false)
    const [showMULTI_PRCE, setshowMULTI_PRCE] = useState(false)
    

    useEffect(() => {
        (async () => {
            try {
                if (isNew)
                {
                    // get AC Info
                    //console.log("StkDepWithTranEntryEdit StkDepWith.d_acCode: ", StkDepWith.d_acCode, AcCodeValue) 
                    const res = await gsb.post('/Master', {sb_data: "", cPgmId: "Clmast", cAction: "GetACInfo", cAcCode: AcCodeValue})
                    //console.log("StkDepWithTranEntryEdit GetACInfo data : ", res.data.data) 
                    //console.log("StkDepWithTranEntryEdit GetACInfo  count: ", res.data.count) 
                    
                    if ( AcCodeValue.trim().length > 0 && res.data.count > 0 )
                    {
                        setAcName1Value(res.data.data[0].d_acName1.trim())
                        setAcName2Value(res.data.data[0].d_acName2.trim())

                      
                    
                    } else { 
                        setAcName1Value("")
                        setAcName2Value("")
 
                    }
                }
            
            } catch (error) {
                //showErrorBox(error)
            }
        })()

    }, [gsb, AcCodeValue])

    
    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
                // setuserKey(GsbFlag.user_key)
                // setGSBx_USER(GsbFlag.GSBx_USER) ;
                // setdateFormat(GsbFlag.dateFormat)
            } catch (error) {
                //utils.showError(error)
            }
        })()
    }, [gsb])  

 
    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
 
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }

                setshowChannel( GsbFlag.MULTI_CHNL ) ;
                setshowMULTI_PRCE( GsbFlag.MULTI_PRCE ) ;

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])  

        useEffect(() => {
        // Call reset to get the values of record StkInfo 
        if ("d_acCode" in ac) {
            reset(ac)
        }
    }, [ac, reset])
 
    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])
     
    
    if (! isNew && ! ("d_acCode" in ac)) return null

    const onSubmit = (data: ClUploadInfo) => {


                     // put value to json/field before write database dbf
        data.d_acCode = AcCodeValue;
        if ( typeof(data.d_acCode) === "undefined" ) {
            data.d_acCode = ""
        }
        data.d_acCode = data.d_acCode.toUpperCase();
 
        data.d_acName1 = AcName1Value.trim()
        data.d_acName2 = AcName2Value.trim()
 
        data.d_NOCOM = def_d_NOCOM;
        data.d_CCROPT = def_d_CCROPT;
        
        //data.d_tr
        data.d_AuthTran = ""
        if (isReqAuth) {
            data.d_AuthTran = "Y"
        }

        (async () => {
            try {
                console.log("call CCRClientUploadEntryEdit data", data)
                console.log("call CCRClientUploadEntryEdit isNew", isNew)
                const res = await gsb.post('/Master', {sb_data: data, cPgmId: "CCRClientUploadEntry", cAction: "Validate", isNew: isNew})
                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                        setError(res.data.data[j][0], {
                            message: res.data.data[j][1]
                        }); 
                    }
                    return
                }
             
                onSave(data)
               
            } catch (error) {
                showErrorBox(error)
                utils.showError(error)
            }
        })()
        
    }
    

       
    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }
       
    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }
       
       
    const handleViewInfoClick = (event: any): void => {
        event.preventDefault()    
        
        } 

    
    /*<form onSubmit={handleSubmit(onSubmit)}>*/
    return (
        <form onKeyDown={handleHotkey}>
            <ClientPicker gsb={gsb} isOpen={isClPickerOpen} onClose={()=>setIsClPickerOpen(false)} onSelect={(ac)=>{setClCodeValue(ac.d_acCode); setIsClPickerOpen(false)}}/>
          
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>
                <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Save</Button>

            </div>
     
            <div className="Spacing-V-16" />
            <div className="Row"> 
                <FormGroup className="Col-1-2" label="Client A/C No." labelFor="inputacCode" labelInfo="*">
                    <InputGroup disabled={!isNew} id="inputacCode" value={AcCodeValue} defaultValue="" placeholder="Account No. ..." onChange={utils.handleStringChange(s => setAcCodeValue(s.toUpperCase())) } inputRef={register({ required: true }) } 
                        rightElement={<Button icon="double-chevron-down" minimal onClick={() => {setSetClCodeValue(()=>setAcCodeValue); setIsClPickerOpen(true)}}></Button>}
                    />
                    {errors.d_acCode && errors.d_acCode.type === "required" && <span id="Err_msg">Account No. cannot be Blank</span>}         
                    {errors.d_acCode && errors.d_acCode.types && <span id="Err_msg">{errors.d_acCode.types.message}</span>}
                </FormGroup>


                <FormGroup className="Col-1-4" label="Name" labelFor="inputacName1" labelInfo="*">
                    <InputGroup  id="inputacName1" name="d_acName1" autoFocus={isNew} value ={AcName1Value} defaultValue="" placeholder="Name1" onChange={utils.handleStringChange(s => setAcName1Value(s.toUpperCase())) }  inputRef={register({ required: true ,maxLength:40}) } />
                    <InputGroup  id="inputacName2" name="d_acName2" autoFocus={isNew} value={AcName2Value} defaultValue="" placeholder="Name2"  onChange={utils.handleStringChange(s => setAcName2Value(s.toUpperCase())) }  inputRef={register({ required: false ,maxLength:40}) } />
                
                    {/* GsbErrors[0].field_error &&<span id="Err_msg">{GsbErrors[0].field_message}</span> */}
                    {errors.d_acName1 && errors.d_acName1.types && <span id="Err_msg">{errors.d_acName1.types.message}</span>}
                    {errors.d_acName2 && errors.d_acName2.types && <span id="Err_msg">{errors.d_acName2.types.message}</span>}
                </FormGroup>           

            </div>                    
            <div className="Spacing-V-16" />
            <div className="Row">              
 
                <FormGroup className="Col-1-3" label="Upload Address TO CCASS">             
                    <select  id="inputCCOMPOPT"   value={def_d_NOCOM} onChange={utils.handleStringChange(s => setdef_d_NOCOM(s)) } ref={register}>                     
                        <option value="">None</option>       
                        <option value="Y">Y-Upload</option>                                   
                        <option value="B">B-Upload Broker Address</option>
        
                    </select>   
                    <div>(Y=Upload, B=Upload Broker Address)</div>
                </FormGroup>  

                <FormGroup className="Col-1-2" label="Receive Option (1-8)">  
                    <select  id="inputCCOMPOPT"   value={def_d_CCROPT} onChange={utils.handleStringChange(s => setdef_d_CCROPT(s)) }  ref={register}>      
                        <option value="">None</option>                                     
                        <option value="1"> 1. to be specified by issuer </option>   
                        <option value="2"> 2. completed financial report (Chi,Eng) and general notice (Chi,Eng)</option>   
                        <option value="3">3. brief financial report (Chi,Eng) and general notice (Chi,Eng)</option>   
                        <option value="4"> 4. completed financial report (Eng) and general notice (Eng)</option>   
                        <option value="5"> 5. completed financial report (Chi) and general notice (Chi)</option>   
                        <option value="6"> 6. brief financial report (Eng) and general notice (Eng)</option>   
                        <option value="7"> 7. brief financial report (Chi) and general notice (Chi)</option>   
                        <option value="8"> 8. receive notice by e-mail and obtain information through web browsing</option> 
                    </select>   
                    
                </FormGroup>        


                
            </div>

        
     
       
            
        </form>
    )
}

interface ClientUploadEntryMainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})

function ClientUploadEntryMain({ gsb }: ClientUploadEntryMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    let url = document.location.toString()
    let qString = url.substr(url.indexOf("?"))

    let { acCode: defaultSearchValue = "" }: { acCode: string } = useParams()

    let logKey = utils.getUrlParameter('logKey', url); 
    let logKey2 = logKey.substr(0,logKey.indexOf("?")); 
    let logviewonly = utils.getUrlParameter('logviewonly', url); 
 
    const [data, setData] = useState([] as ClUploadInfo[])
    
 
    const [searchKey, setSearchKey] = useState("acCode")
    const [searchValue, setSearchValue] = useState(defaultSearchValue)
    const [searchStkName, setsearchStkName] = useState("")
    const [SearchNOCOM, setSearchNOCOM] = useState("")

    const [searchApplyDate, setsearchApplyDate] = useState("")

 
    const [showFilters, setShowFilters] = useState(false)

 
    const [s_AcStatus, sets_AcStatus] = useState("")

    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [aPageShowInfo, setaPageShowInfo] = useState([] as PageInfo2[])
    const [PageReachEnd, setPageReachEnd] = useState(false)
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("list")
    const [currentAc, setCurrentAc] = useState({} as ClUploadInfo)
    const [currentAc2, setCurrentAc2] = useState({} as ClUploadInfo)


    //MailInfo
    const [BlankAc, setBlankAc] = useState({} as ClUploadInfo)
    const [CurrentLog1, setCurrentLog1] = useState({} as ClUploadInfo)
    const [CurrentLog0, setCurrentLog0] = useState({} as ClUploadInfo)
    const [ViewMode, setViewMode] = useState("V")

    const [currentMode, setCurrentMode] = useState("show")
    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")
    const [SUSPEND_AC, setSUSPEND_AC] = useState(false)
    
    const [showCurrency, setshowCurrency] = useState(false)
    const { t, i18n } = useTranslation();
 

    BlankAc.d_acCode =""
    BlankAc.d_NOCOM =""
    BlankAc.d_AuthTran = "N"
    BlankAc.d_acName1 = ""
    BlankAc.d_acName2 = ""
    BlankAc.d_CCROPT=""
 

     useEffect(() => {
         (async () => {
             try {
                 // get GsbFlag from SB.XBS
                 const res = await gsb.post('/GsbFlag');
                 //console.log("PayRecTranEntryMain disp user_key: ", res.data.Flag.user_key)
                 //console.log("PayRecTranEntryMain disp MULTI_MKT: ", res.data.Flag.MULTI_MKT)
                 //console.log("PayRecTranEntryMain disp data.Flag: ", res.data.Flag)
                 GsbFlag = res.data.Flag;
                 //console.log("PayRecTranEntryMain disp GsbFlag: ", GsbFlag)
                 //console.log("PayRecTranEntryMain disp GsbFlag.lang: ", GsbFlag.lang)
                 //console.log("PayRecTranEntryMain disp GsbFlag.dateFormat: ", GsbFlag.dateFormat)
                 console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                 //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                 UserID = res.data.Flag.UserID
                 //console.log("PayRecTranEntryMain disp GsbFlag.MULTI_MKT: ", sbFlag.MULTI_MKT)
                 //console.log("PayRecTranEntryMain disp GsbFlag.MGNGP_USER: ", GsbFlag.MGNGP_USER)
                 //console.log("PayRecTranEntryMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                 setCO_NAME( GsbFlag.CO_NAME) ;
                 setcompanyLogoName( GsbFlag.companyLogoName) ;
                 setSBPath( GsbFlag.SBPath) ;
                 setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                 setSETL_DATE(GsbFlag.SETL_DATE ) ;
                 if ( GsbFlag.isProduction == "Y" ) {
                     setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                 } else {
                     setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                 }
 
                 setshowCurrency( (GsbFlag.MULTI_MKT) && ( ! GsbFlag.SING_CURR) );
              
             } catch (error) {
                 utils.showError(error)
             }
         })()
     }, [gsb])

  


    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');        
                GsbFlag = res.data.Flag;
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
             
                UserID = res.data.Flag.UserID  
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
                setSUSPEND_AC(GsbFlag.SUSPEND_AC);

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

 
    useEffect(() => {
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("ClientUploadEntryMain UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            //setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID])



    const PrevRecProcess = async (Mail: ClUploadInfo) => {
        try {
            //console.log("call PrevRecProcess", ac)
            const res = await gsb.post('/Master', {sb_data: Mail, cPgmId: "CCRClientUploadEntry", cAction: "PrevRec"})
            //console.log("PrevRecProcess res.data : ", res.data.data)
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")

        } catch (error) {
            utils.showError(error)
        }
    }
 
   
  
    const DeleteProcess = async (Mail: ClUploadInfo) => {
        try {
            Mail.d_AuthTran = ""
            if (isReqAuth2) {
                Mail.d_AuthTran = "Y"
            }
            //console.log("call DeleteProcess", stk)
            const res = await gsb.post('/Master', {sb_data: Mail, cPgmId: "CCRClientUploadEntry", cAction: "DelRec"})
            if (res.data.ok) {
                if (isReqAuth2) {
                    showSuccess("Account No. " + Mail.d_acCode +" record deleting, waiting for authorization")
                } else {
                    showSuccess("Account No. " + Mail.d_acCode +" record deleted")
                    for (let i = 0; i < data.length; i++) {
                        if (data[i].d_acCode === res.data.data.d_acCode) {
                            data[i] = { ...data[i], ...res.data.data }
                            setData(data)
                            break
                        }
                    }
                }
                setCurrentAc(res.data.data)               
                setCurrentMode("show")
                if (isReqAuth2) {
                    alert("Account No. " + Mail.d_acCode +"  record deleting, waiting for authorization")
                }
            } else {
                setisShowAlert2(true)
                setShowAlert2Msg(res.data.err_Msg)
            }
        } catch (error) {
            utils.showError(error)
        }
    }

    const NextRecProcess = async (Mail: ClUploadInfo) => {
        try {
            console.log("call NextRecProcess", Mail)
            const res = await gsb.post('/Master', {sb_data: Mail, cPgmId: "CCRClientUploadEntry", cAction: "NextRec"})
            //console.log("NextRecProcess show 1: ", stk.d_StkNo)
            console.log("NextRecProcess data : ", data)
            console.log("NextRecProcess res.data : ", res.data.data)
                //console.log("PrevRecProcess res.data.data : ", res.data.data)
            setCurrentAc(res.data.data)
            //console.log("PrevRecProcess show 2: ", stk.d_StkNo)
            setCurrentMode("show")
            //console.log("PrevRecProcess show 3: ", stk.d_StkNo)
        } catch (error) {
            utils.showError(error)
        }
    }

    const newOnSave = async (Mail: ClUploadInfo) => {
        try {


           
            //console.log("call newOnSave", Mail)
            const res1 = await gsb.post('/GsbFlag');
            //console.log("MenuBar disp user_key: ", res.data.Flag.user_key)
            GsbFlag = res1.data.Flag;
            


            //console.log("MenuBar disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
            const res = await gsb.post('/Master', {sb_data: Mail, cPgmId: "CCRClientUploadEntry", cAction: "AddRec"})
            if (isReqAuth2) {
                showSuccess(" Account No. [" + Mail.d_acCode + "] record adding, waiting for authorization")
            } else {
                showSuccess(" Account No. [" + Mail.d_acCode + "] record added")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_acCode === res.data.data.d_acCode) {
                        data[i] = { ...data[i], ...res.data.data }
                    
                        setData(data)
                        break
                    }
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
            if (isReqAuth2) {
                alert(" Account No. [" + Mail.d_acCode + "] record adding, waiting for authorization")
            }
        } catch (error) {
            utils.showError(error)
           
        }
    }


    const editOnSave = async (Mail: ClUploadInfo) => {
        try {
            console.log("call editOnSave", Mail)
             //console.log("call newOnSave", Mail)
            const res1 = await gsb.post('/GsbFlag');
             //console.log("MenuBar disp user_key: ", res.data.Flag.user_key)
            GsbFlag = res1.data.Flag;
             
/*

     (async () => {
            try {
                console.log("call ClientUploadEntryEdit data", data)
                console.log("call ClientUploadEntryEdit isNew", isNew)
                const res = await gsb.post('/Master', {sb_data: data, cPgmId: "CCRMailList", cAction: "Validate", isNew: isNew})
                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                        setError(res.data.data[j][0], {
                            message: res.data.data[j][1]
                        }); 
                    }
                    return
                }
             
                onSave(data)
               
            } catch (error) {
                showErrorBox(error)
                utils.showError(error)
            }
        })()
*/

            console.log("call CCRClientUploadEntryEdit data", data)
           
            ///const res3 = await gsb.post('/Master', {sb_data: Mail, cPgmId: "CCRMailList", cAction: "Validate", isNew: false})
       
            const res = await gsb.post('/Master', {sb_data: Mail, cPgmId: "CCRClientUploadEntry", cAction: "UpdateRec"})
            if (isReqAuth2) {
                console.log("Account No. " + Mail.d_acCode + " record saving, waiting for authorization")
               showSuccess("Account No. " + Mail.d_acCode + " record saving, waiting for authorization")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_acCode === res.data.data.d_acCode) {
 
                        setCurrentAc(data[i])
                        break
                    }
                }
                setCurrentMode("show")
                //alert("Account No. " + Bcan.d_acCode + " record saving, waiting for authorization")
                setisShowAlert1(true)
                setShowAlert1Msg("Account No. " + Mail.d_acCode + " record saving, waiting for authorization")
                //console.log("Account No. " + Mail.d_acCode + " record saving, waiting for authorization")
            } else {
           
                console.log("Account No. " + Mail.d_acCode + " record saved")
                showSuccess("Account No. " + Mail.d_acCode + " record saved")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_acCode === res.data.data.d_acCode) {
                        data[i] = { ...data[i], ...res.data.data }
                        setData(data)
                        break
                    }
                }
              
                setCurrentMode("show")
              
                setCurrentAc(res.data.data)
                setCurrentMode("show")
                console.log("call editOnSaved", Mail)
            }
        } 
        catch (error) {
            utils.showError(error)
        }
        
    }

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

        setShowWait(true)
        setnPage(1)
       // setnTotalPage(0)
       // setPageReachEnd(false)

        let m_limit = searchLimit
        if ( selectedTabId === "detail" ) {
            m_limit = 1
        }

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }

        try {
            if ( m_limit > 1 ) {
                const res = await gsb.post('/Master',
                    {   sb_data: {
                        by: searchKey,
                        start: searchValue,
                        nPage: 1,
                        limit: m_limit,
                        backward: searchBackward,
                        filters: {                                
                            NOCOM:SearchNOCOM,
                        }, 
                    },
                    cPgmId: "CCRClientUploadEntry",
                    cAction: "ListRec",
                });


                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setCurrentAc(res.data.data[0])
                }
                
                if ( res.data.count > 0 ) {
                    const aPageNumber1 = []
                    if ( res.data.count > 0 ) {
                        setnTotalPage(Math.ceil(res.data.count / searchLimit))
                        for ( let j = 1; j <= Math.ceil(res.data.count / searchLimit); j++ ) {
                            aPageNumber1.push({n: j});
                        }
                        setaPageNumber(aPageNumber1)
                    }
                }
            } else {
                const res = await gsb.post('/Master',
                {   sb_data: {
                        d_acCode: searchValue,
                        nPage: 1,
                        limit: m_limit,
                    },
                    cPgmId: "CCRClientUploadEntry",
                    cAction: "GetRec",
                });

                if ( res.data.ok ) {
                    console.log("GetRec res.data.data", res.data.data)
                    setCurrentAc(res.data.data)
                    setCurrentMode("show")
                } else {
                   // alert(res.data.data)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res.data.data)
                }
            }
            setShowWait(false)
        } catch (error) {
            setShowWait(false)
            utils.showError(error)
        }
    }

   //Press page No 1 2 3 4
      useEffect(() => {
          if ( nPage > 0 && nPage <= nTotalPage && selectedTabId == "list" ) {
      
              setShowWait(true)
              if ( nPage > 0 ) {
                  //setcPrintMode("S")
              } 
      
              (async () => {
                  try {
                      //console.log("IntRMastMain useEffect nPage > 0  ", nPage)
                      const res = await gsb.post('/Master',
                      {   sb_data: {
                              by: searchKey,
                              start: searchValue,
                              nPage: nPage,
                              limit: searchLimit,
                              backward: searchBackward,
                              filters: {                                
                                NOCOM:SearchNOCOM,
                              }, 
                          },
                          cPgmId: "CCRClientUploadEntry",
                          cAction: "ListRec",
                      });
  
                      setData(res.data.data)
                      if (res.data.data.length > 0) {
                          setCurrentAc(res.data.data[0])
                      }
                      setShowWait(false)
          
                  } catch (error) {
                      utils.showError(error)
                  }
              })()
          }
      }, [gsb, nPage, selectedTabId])


    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }

    // currentMode = show
    let detail = <ClientUploadEntryView gsb={gsb} ac={currentAc} ac0={currentAc}  baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentAc)} onNew={() => setCurrentMode("new")}  onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentAc)} onNextRec={() => NextRecProcess(currentAc)} ViewMode={ViewMode} logKey2={logKey2.trim()} PgmMode="MailList" ></ClientUploadEntryView>
    switch (currentMode) {
       case "new":

            console.error("new" )
            detail = <ClientUploadEntryEdit gsb={gsb} ac={BlankAc}   isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } } PgmMode="MailList" ></ClientUploadEntryEdit>
            break
        case "edit":
          
            detail = <ClientUploadEntryEdit gsb={gsb} ac={currentAc}  onSave={editOnSave} onCancel={() => setCurrentMode("show")} PgmMode="MailList" ></ClientUploadEntryEdit>
            break
 
    }

    let logKeyViewRec = <ClientUploadEntryView gsb={gsb} ac={CurrentLog1} ac0={CurrentLog0}  baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentAc)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentAc)} onNextRec={() => NextRecProcess(currentAc)} ViewMode={ViewMode} logKey2={logKey2.trim()} PgmMode="MailList"  ></ClientUploadEntryView>

   // let logKeyViewRec = <ClientUploadEntryView gsb={gsb} Mail={CurrentLog1} Ac0={CurrentLog0}   baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentAc)} onNew={() => setCurrentMode("new")}  onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentAc)} onNextRec={() => NextRecProcess(currentAc)} ViewMode={ViewMode} logKey2={logKey2.trim()} PgmMode="MailList"  ></ClientUploadEntryView>
    function PageNo(n: number) {
        if (n > 0 ) {
            if (  nPage+n <= nTotalPage || nTotalPage == 0 ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }
 
 
    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nPage > 0) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                 {aPageNumber.map((no, j) => 
                    (no.n < nPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (no.n > nPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nPage > 0) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
                { (nPage > 0) && ! ( PageReachEnd ) &&
                    <Button minimal >...</Button>
                }
            </FormGroup>
        </div>
    </>
 
    
    let list = <>
        {/*
        <div className="Row">
            <Button className="Col-1-1" icon="add" onClick={() => { setCurrentMode("new"); setSelectedTabId("detail") }}>New</Button>
        </div>
        */}
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
        {/* display search list */}
        <HTMLTable striped interactive condensed>
            <thead>                                  
                <th className="TCol-StkCode">CLIENT A/C NO.</th>
                <th className="TCol-StkNo">Name1</th>
                <th className="TCol-StkNo">Name2</th>       
                <th className="TCol-PY_date">Upload Address To CCASS</th>                                                  
                <th className="TCol-StkNo">Receive Option</th>   
         
            </thead>
            <tbody id="ma_tr">
                {data.map((Mail, i) =>
                    <tr key={i} onDoubleClick={() => { setSelectedTabId("detail") }}>
                  
                        <td className="TCol-StkCode" onClick={() => { setCurrentAc(Mail) ; MoblieDev && setSelectedTabId("detail") }}>{Mail.d_acCode}</td>                        
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(Mail) ; MoblieDev && setSelectedTabId("detail") }}>{Mail.d_acName1}</td>
                        <td className="TCol-StkCode" onClick={() => { setCurrentAc(Mail) ; MoblieDev && setSelectedTabId("detail") }}>{Mail.d_acName2}</td>
                        <td className="TCol-StkCode" onClick={() => { setCurrentAc(Mail) ; MoblieDev && setSelectedTabId("detail") }}>{Mail.d_NOCOM}</td>                      
                        <td className="TCol-StkCode" onClick={() => { setCurrentAc(Mail) ; MoblieDev && setSelectedTabId("detail") }}>{Mail.d_CCROPT}</td>         
      
                    </tr>
                )}
            </tbody>
        </HTMLTable>
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>
    return (
        <>
            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                { ! ( logviewonly === "Y" ) && <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H4><div style={{justifyContent: 'flex-end'}}>Client Upload Entry</div></H4>
                    <div className="Row No-Print">
                        <FormGroup className="Col-1-5" label="Search for" labelFor="inputSearchValue">
                            <ControlGroup fill>
                                <HTMLSelect className={Classes.FIXED} value={searchKey} onChange={utils.handleStringChange(s => setSearchKey(s))}>                                   
                                    <option value="acCode">Account</option>
                                    <option value="acName">Name</option>
                                                                      
                                    {/* <option value="_recordNo">Record No.</option> */}
                                </HTMLSelect>
                                <InputGroup
                                    id="inputSearchValue"
                                    placeholder="Search"
                                    value={searchValue}
                                    onChange={utils.handleStringChange(s => setSearchValue(s))}
                                    leftIcon="search"
                                    rightElement={<Button icon={IconNames.ARROW_RIGHT} disabled={(selectedTabId === "detail" && ! (searchKey == "acCode"))} minimal type="submit"></Button>}
                                />
                            </ControlGroup>
                        </FormGroup>
                        <Button className="Col-6-1 Button-LabeledFormGroup" icon="search" disabled={(selectedTabId === "detail" && ! (searchKey == "acCode"))} type="submit" >{(selectedTabId === "detail") ? "Search" : "List"}</Button>
                        {/* <Checkbox className="Col-6-1 Checkbox-LabeledFormGroup" label="Backward" onChange={utils.handleBooleanChange(v => setSearchBackward(v))} /> */}
                        <Button className="Col-7-1 Button-LabeledFormGroup" icon="filter" onClick={() => { setShowFilters(!showFilters) }} >Filters</Button>
                    </div>
                    <Collapse isOpen={showFilters}>
                        <div className="Row">
            
                            <FormGroup className="Col-1-2" label="Upload Address To CCASS" labelFor="searchNOCOMM">
                                <select  id="SearchNOCOMM" value={SearchNOCOM} onChange={utils.handleStringChange(s => setSearchNOCOM(s))}>
                                    <option value="">None </option>
                                    <option value="Y">Y=Upload</option>  
                                    <option value="B">B=Upload Broker Address</option>
                                </select>
                            </FormGroup>    
                        </div>
                    </Collapse>
                  
                    <Tabs onChange={(newTabId) => setSelectedTabId(newTabId as string)} selectedTabId={selectedTabId}>
                        <Tab id="list" title="List" panel={list} />
                        <Tab id="detail" title="Detail" panel={detail} />
                    </Tabs>
                </Card> }
                {ViewMode === "L" && <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>Client Upload Entry Log View</H3>
                    <div className="Spacing-V-16" />
                    {/*logKeyViewRec*/}
                </Card> }

                <div className="Spacing-V-16"></div>
                    <Alert
                        confirmButtonText="OK"
                        icon="tick-circle"
                        intent={Intent.SUCCESS}
                        isOpen={isShowAlert1}
                        onCancel={ () => setisShowAlert1(false) }
                        onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
                    >
                        <p>
                            {ShowAlert1Msg}
                        </p>
                    </Alert>
                    <Alert
                        confirmButtonText="OK"
                        icon="cross"
                        intent={Intent.WARNING}
                        isOpen={isShowAlert2}
                        onCancel={ () => setisShowAlert2(false) }
                        onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
                    >
                        <p>
                            {ShowAlert2Msg}
                        </p>
                    </Alert>
            </form>
        </>
    );
}

export default ClientUploadEntryMain



